/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdetailnoimages3Inputs */

const en_eventdetailnoimages3 = /** @type {(inputs: Eventdetailnoimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pictures yet.`)
};

const de_eventdetailnoimages3 = /** @type {(inputs: Eventdetailnoimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bilder.`)
};

/**
* | output |
* | --- |
* | "No pictures yet." |
*
* @param {Eventdetailnoimages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdetailnoimages3 = /** @type {((inputs?: Eventdetailnoimages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdetailnoimages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdetailnoimages3(inputs)
	return de_eventdetailnoimages3(inputs)
});
export { eventdetailnoimages3 as "eventDetailNoImages" }